/**
 * Returns the value of the "lang" search parameter as uppercase if it exists, otherwise returns null.
 * @returns {string|null} The value of the "lang" search parameter as uppercase if it exists, otherwise null.
 */
export const getPreferredLanguage = () => {
    const urlParameters = new URLSearchParams(window.location.search);

    const langParam = urlParameters.get("lang");
    return langParam ? langParam.toUpperCase() : null;
};
